(function () {
  'use strict';

  /* ================================================================
     NewPharma — carrusel de "¿Como te sientes hoy?"

     EL DESLIZAMIENTO LO HACE EL NAVEGADOR, no este archivo. El track
     es un `overflow-x: auto` con `scroll-snap-type: x mandatory`: el
     gesto con el dedo, la inercia, la rueda horizontal y el scroll por
     teclado ya vienen resueltos y se sienten nativos.

     Este script hace cinco cosas:
       - clonar las tarjetas para que el carrusel sea un BUCLE
       - mover el track cuando se pulsan las flechas o un punto
       - pintar el punto activo al desplazarse
       - normalizar el scroll cuando se sale del juego del medio
       - AVANZAR SOLO cada N segundos (ajuste "Cambia cada")

     Si no corre, el carrusel se sigue pudiendo deslizar con el dedo y
     las tarjetas siguen siendo enlaces: lo que se pierde es el bucle,
     las flechas y el avance, no el contenido.
     ================================================================ */

  function arrancar(raiz) {
    if (raiz.dataset.npNecActivo) return;
    raiz.dataset.npNecActivo = '1';

    var track = raiz.querySelector('[data-np-nec-track]');
    if (!track) return;

    var originales = [].slice.call(track.querySelectorAll('.np-nec__card'));
    var dots = [].slice.call(raiz.querySelectorAll('[data-np-nec-dot]'));
    var prev = raiz.querySelector('[data-np-nec-prev]');
    var next = raiz.querySelector('[data-np-nec-next]');
    var n = originales.length;

    if (n < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ----------------------------------------------------------------
       EL BUCLE: un juego de clones antes y otro despues.

       El carrusel arranca en el juego DEL MEDIO, asi que desde la
       primera tarjeta ya se ve otra a la izquierda. Cuando el scroll
       sale de ese tramo se le resta o se le suma el ancho de un juego
       **sin animacion**: el contenido es identico, asi que el salto no
       se ve. Es la unica forma de que `scroll-snap` nativo —que no
       sabe de bucles— se comporte como uno.

       Los clones son decorativos: `aria-hidden` y `tabindex="-1"` para
       que un lector de pantalla no lea nueve necesidades tres veces y
       el tabulador no recorra 27 enlaces.

       Tambien se les quitan los `data-shopify-*`: son los que el editor
       usa para saber a que bloque pertenece cada nodo, y duplicarlos lo
       confundiria al seleccionar un bloque.
       ---------------------------------------------------------------- */
    function clonar(nodo) {
      var c = nodo.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      c.dataset.npNecClon = '1';
      for (var k = c.attributes.length - 1; k >= 0; k--) {
        var a = c.attributes[k].name;
        if (a.indexOf('data-shopify') === 0) c.removeAttribute(a);
      }
      return c;
    }

    var antes = document.createDocumentFragment();
    var despues = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      antes.appendChild(clonar(originales[i]));
      despues.appendChild(clonar(originales[i]));
    }
    track.insertBefore(antes, track.firstChild);
    track.appendChild(despues);

    // Las 3n tarjetas en orden. Las reales son las de n a 2n-1.
    var cards = [].slice.call(track.querySelectorAll('.np-nec__card'));

    var pendiente = false;
    var actual = 0;
    var reloj = null;
    var relojNorm = null;
    var quieto = false;
    var visible = false;

    /* El indice sale de comparar el scroll con la POSICION REAL de cada
       tarjeta, no de dividir por un ancho supuesto: con `gap` y con
       padding lateral, `scrollLeft / anchoTarjeta` se desfasa a la
       tercera o cuarta. */
    function indiceAbs() {
      var x = track.scrollLeft;
      var mejor = 0, dist = Infinity;
      for (var k = 0; k < cards.length; k++) {
        var d = Math.abs(cards[k].offsetLeft - track.offsetLeft - x);
        if (d < dist) { dist = d; mejor = k; }
      }
      return mejor;
    }

    function real(abs) { return ((abs - n) % n + n) % n; }

    function irAbs(k, instantaneo) {
      if (k < 0) k = 0;
      if (k > cards.length - 1) k = cards.length - 1;
      var destino = cards[k].offsetLeft - track.offsetLeft;
      if (reduce || instantaneo) track.scrollLeft = destino;
      else track.scrollTo({ left: destino, behavior: 'smooth' });
    }

    /* Volver al juego del medio. Se hace con el scroll QUIETO —140 ms
       sin un solo evento— y no en cada evento: reposicionar a mitad de
       un gesto o de una animacion suave la corta en seco. */
    function normalizar() {
      var a = indiceAbs();
      if (a >= n && a < n * 2) return;
      irAbs(n + real(a), true);
    }

    function pintar() {
      pendiente = false;
      var i = real(indiceAbs());
      if (i === actual) return;
      actual = i;
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-activo', d === i);
      }
    }

    function alScroll() {
      if (!pendiente) {
        pendiente = true;
        window.requestAnimationFrame(pintar);
      }
      if (relojNorm) clearTimeout(relojNorm);
      relojNorm = setTimeout(normalizar, 140);
    }

    /* ----------------------------------------------------------------
       AVANCE AUTOMATICO

       `0` apaga el avance, y con `prefers-reduced-motion` no arranca
       nunca: un carrusel que se mueve solo es exactamente lo que ese
       ajuste pide evitar. Las flechas y los puntos quedan igual, asi
       que la seccion se sigue pudiendo recorrer entera.

       Se detiene mientras el mouse esta encima, mientras el foco del
       teclado esta adentro, con la pestana en segundo plano y cuando
       la seccion no se ve. Lo ultimo importa de verdad: sin eso, al
       llegar scrolleando la seccion ya estaria en la septima tarjeta.
       ---------------------------------------------------------------- */
    var espera = parseInt(raiz.getAttribute('data-auto'), 10);
    if (isNaN(espera)) espera = 0;
    var ms = espera * 1000;

    function puedeCorrer() {
      return ms > 0 && !reduce && !quieto && visible && !document.hidden;
    }

    function rearmar() {
      if (reloj) { clearTimeout(reloj); reloj = null; }
      if (!puedeCorrer()) return;
      reloj = setTimeout(function () {
        reloj = null;
        if (!puedeCorrer()) return;
        // Siempre hacia adelante: del bucle se encarga `normalizar`.
        irAbs(indiceAbs() + 1);
        rearmar();
      }, ms);
    }

    function frenar() { quieto = true; rearmar(); }
    function soltar() { quieto = false; rearmar(); }

    raiz.addEventListener('mouseenter', frenar);
    raiz.addEventListener('mouseleave', soltar);
    raiz.addEventListener('focusin', frenar);
    raiz.addEventListener('focusout', function (ev) {
      if (!raiz.contains(ev.relatedTarget)) soltar();
    });
    // Tocar la seccion en un telefono la deja quieta: ahi no hay
    // "mouseleave" que la despierte y seria molesto que se mueva sola
    // mientras alguien la esta mirando.
    raiz.addEventListener('touchstart', frenar, { passive: true });
    document.addEventListener('visibilitychange', rearmar);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
        rearmar();
      }, { threshold: 0.35 }).observe(raiz);
    } else {
      // Sin observador no hay forma de saber si se ve: se deja correr.
      visible = true;
    }

    /* EL SCROLL DEL TRACK NO REARMA EL RELOJ. Lo hacia, y cada evento
       del desplazamiento suave —que son decenas— volvia a poner los
       cinco segundos a cero: el intervalo real salia de 5 s a 7. Lo que
       posterga el avance es la INTENCION del cliente (mouse encima,
       foco adentro, dedo sobre la seccion), no el movimiento que el
       propio reloj acaba de provocar. */
    track.addEventListener('scroll', alScroll, { passive: true });

    // Al cambiar el ancho cambian los `offsetLeft`: se recoloca sin
    // animacion sobre la tarjeta que estaba a la vista.
    window.addEventListener('resize', function () {
      irAbs(n + actual, true);
    }, { passive: true });

    // Con bucle las flechas nunca se agotan.
    if (prev) {
      prev.disabled = false;
      prev.addEventListener('click', function () { irAbs(indiceAbs() - 1); });
    }
    if (next) {
      next.disabled = false;
      next.addEventListener('click', function () { irAbs(indiceAbs() + 1); });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        irAbs(n + (parseInt(d.getAttribute('data-np-nec-dot'), 10) || 0));
      });
    });

    // Arrancar en el juego del medio, para que ya se vea una tarjeta a
    // cada lado. Va sin animacion: es la posicion de partida.
    irAbs(n, true);
    pintar();
    rearmar();
  }

  function init() {
    var nodos = document.querySelectorAll('[data-np-nec]');
    for (var i = 0; i < nodos.length; i++) arrancar(nodos[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // El editor redibuja la seccion al cambiar un ajuste
  document.addEventListener('shopify:section:load', init);
})();
